import { forEach, uniqWith } from 'lodash';
import { BODY_TYPE_FILTER_CATEGORY, PAYMENT_OPTION_TYPE_FILTER_CATEGORY, } from '../../../core/reducers/vehicleListFilters';
import { sortPaymentMethods } from '../../../core/utils';
import { MODEL_CARD_GRID_USAGE } from './constants';
const getUniqueModelCards = (modelCards) => uniqWith(modelCards, (a, b) => a.modelKey === b.modelKey && a.year === b.year);
const getModelCards = (data, componentUsedIn = MODEL_CARD_GRID_USAGE.UNKNOWN) => {
    if (!Array.isArray(data) && !data)
        return [];
    const modelCards = [];
    forEach(data, model => {
        if (!model)
            return;
        forEach(model.modelYears, modelYear => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
            const { defaultTrim } = modelYear;
            if (!defaultTrim || !defaultTrim.fields)
                return;
            // exclude models that have been excluded from inventory
            if (((_a = modelYear.excludeFromInventory) === null || _a === void 0 ? void 0 : _a.value) === '1' && componentUsedIn === MODEL_CARD_GRID_USAGE.INVENTORY)
                return;
            const trimName = (_b = modelYear.trims.find(trim => trim.detKey.value === defaultTrim.fields.detKey.value)) === null || _b === void 0 ? void 0 : _b.name;
            const defaultTransmissionKey = defaultTrim.fields.defaultTransmission.item.detKey.value || '';
            const card = {
                modelGtmName: model.name,
                modelName: model.modelName.value,
                year: modelYear.year.value,
                trimKey: defaultTrim.fields.detKey.value,
                defaultTransmission: defaultTransmissionKey,
                trimName,
                trimGtmName: trimName,
                exteriorColorKey: (_h = (_g = (_f = (_e = (_d = (_c = defaultTrim.fields.defaultTransmission) === null || _c === void 0 ? void 0 : _c.item.defaultExteriorColor) === null || _d === void 0 ? void 0 : _d.item) === null || _e === void 0 ? void 0 : _e.color) === null || _f === void 0 ? void 0 : _f.item) === null || _g === void 0 ? void 0 : _g.detKey) === null || _h === void 0 ? void 0 : _h.value,
                interiorColorKey: (_m = (_l = (_k = (_j = defaultTrim.fields.defaultTransmission) === null || _j === void 0 ? void 0 : _j.item.defaultExteriorColor) === null || _k === void 0 ? void 0 : _k.item) === null || _l === void 0 ? void 0 : _l.defaultInteriorColor) === null || _m === void 0 ? void 0 : _m.interiorColor.color.fields.detKey.value,
                primaryThumbnail: (_p = (_o = modelYear.defaultTrim.fields.primaryThumbnail) === null || _o === void 0 ? void 0 : _o.item) === null || _p === void 0 ? void 0 : _p.value,
                secondaryThumbnail: (_r = (_q = modelYear.defaultTrim.fields.secondaryThumbnail) === null || _q === void 0 ? void 0 : _q.item) === null || _r === void 0 ? void 0 : _r.value,
                filters: {
                    [BODY_TYPE_FILTER_CATEGORY]: [],
                },
                driveRange: (_s = model.driveRange) === null || _s === void 0 ? void 0 : _s.value,
                modelKey: model.detKey.value,
                detKey: model.detKey.value,
                detIdentifier: model.detIdentifier.value,
                sotId: model.sotId.value,
                availablePaymentMethods: [],
            };
            forEach(modelYear.trims, trim => {
                var _a;
                const getFiltersByCategory = (category) => {
                    var _a;
                    return (_a = trim.filters) === null || _a === void 0 ? void 0 : _a.items.filter((filter) => { var _a; return ((_a = filter.filterCategory) === null || _a === void 0 ? void 0 : _a.name) === category; });
                };
                const bodyTypeFilters = getFiltersByCategory(BODY_TYPE_FILTER_CATEGORY);
                const paymentOptionsFilters = (_a = getFiltersByCategory(PAYMENT_OPTION_TYPE_FILTER_CATEGORY)) === null || _a === void 0 ? void 0 : _a.map((filter) => filter.name);
                if (!card.availablePaymentMethods.length && trim.detKey.value === card.trimKey) {
                    card.availablePaymentMethods = sortPaymentMethods(paymentOptionsFilters);
                }
                if (!bodyTypeFilters.length)
                    return;
                forEach(bodyTypeFilters, bodyTypeFilter => {
                    var _a, _b;
                    const bodyType = bodyTypeFilter.name;
                    // add this trim's filters to the card
                    if (!((_a = card.filters[BODY_TYPE_FILTER_CATEGORY]) === null || _a === void 0 ? void 0 : _a.includes(bodyType))) {
                        (_b = card.filters[BODY_TYPE_FILTER_CATEGORY]) === null || _b === void 0 ? void 0 : _b.push(bodyType);
                    }
                });
            });
            modelCards.push(card);
        });
    });
    return getUniqueModelCards(modelCards);
};
export default getModelCards;
